///<reference path="smart-mover.models.ts"/>

module Meevo.Components.Controls.SmartMover {
    export interface ISmartMoverTextBase {
        readonly className: {};
        text: string;

        getText($translate: ng.translate.ITranslateService, ...args: any[]): string;
    }

    export class SmartMoverTextBase implements ISmartMoverTextBase {

        get className() {
            return {};
        }

        constructor(public text: string) {
        }

        getText($translate: ng.translate.ITranslateService, ...args: any[]): string {
            return $translate.instant(this.text);
        }
    }
}
